<template>
  <div>
    <div v-if="rewardDetails !== null">
      <div class="reward-name-container"> 
        <h1 class="u-h1">{{ rewardDetails.name }}</h1>
        <h1 v-if="hasRange" class="u-h1"><i class="fa fa-star t-points-icon"></i> {{ $t('web.catalog_rewards_filters.filter_from_points') }} {{minDefDollarPrice}} {{ $t('web.catalog_rewards_filters.filter_to_points') }} {{maxDefDollarPrice}} {{rewardDetails['supplier_items'][0]['currency']}}</h1>
      </div>




      <section class="c-card c-card--reward-images" v-if="rewardDetails.images && rewardDetails.images.length > 0">
        <div class="c-card--reward-images__slider" v-for="image in rewardDetails.images">
          <img :src="image.sizes['350x350']" :alt="image.description" />
        </div>
      </section>




      <section class="c-card c-card--reward-cost">
        <div class="c-card__body c-card--reward-cost__body">
          <div class="c-card--reward-cost__points-cost">
            <h2 class="c-card--reward-cost__points-cost__title t-headline">{{ $t('web.catalog_reward.points_title') }}</h2>


            <p class="c-card--reward-cost__points-cost__data qa-points-cost">
              <i class="fa fa-star t-points-icon"></i>
              <span v-if="hasRange" style="padding-right:5px;">{{ $t('web.catalog_rewards_filters.filter_from_points') }}</span>
              <vue-numeric
                separator  = ","
                :read-only = "true"
                :value    = "hasRange ? minSalePrice : salePrice">
              </vue-numeric>
            </p>
          </div>


          <div class="c-card--reward-cost__points-balance">
            <h2 class="c-card--reward-cost__points-balance__title">{{ $t('web.catalog_reward.current_points') }}</h2>
            <p class="c-card--reward-cost__points-balancedata">
              <i class="fa fa-star"></i>
              <vue-numeric
                separator  = ","
                :read-only = "true"
                v-model    = "participant.points_balance">
              </vue-numeric>
            </p>
          </div>


          <p v-if="!participantHasEnoughPoints" class="u-paragraph u-center-text qa-insufficient-points">
            {{ getInsufficientPointsMessage }}
          </p>


          <button
            v-if       = "!isSavedReward"
            v-on:click = "saveForLater()"
            class      = "c-button
                          c-button--full-width
                          u-margin-bottom-10
                          t-button-plain
                          qa-save-for-later-button"
          >
            {{ $t('web.catalog_reward.save_for_later_button') }}
          </button>

          <div
            v-else
            class  = "c-reward-saved-for-later-button"
          >
            <h3 class="c-reward-saved-for-later-button__title">{{ $t('web.catalog_reward.saved_for_later') }}</h3>
            <div class="c-reward-saved-for-later-button__links">
              <router-link
                :to   = "{ name: 'SavedRewards' }"
                class = "c-reward-saved-for-later-button__links__link
                         t-link
                         qa-view-all-saved"
              >{{ $t('web.catalog_reward.saved_rewards_link') }}</router-link>
              <a
                @click = "deleteItem()"
                :class = "{ 'remove-disabled': deleteProcessing }"
                class  = "c-reward-saved-for-later-button__links__link
                          t-link
                          qa-remove-saved"
              >{{ $t('web.catalog_reward.remove_link') }}</a>
            </div>
          </div>


          <button
            v-on:click = "orderItem()"
            class      = "c-button c-button--full-width t-button-primary"
            :disabled  = "!participantHasEnoughPoints || orderProcessing || (!salePrice > 0 && minSalePrice <= 0)"
          >
              {{ $t('web.catalog_reward.redeem_button') }}
          </button>
        </div>
      </section>



      <!-- Descriptions -->
      <section class="c-card u-card-pad-btm" v-if="rewardDetails.description !== null">
        <div class="c-card__header">
          <h2 class="c-card__header__title t-headline">
            {{ $t('web.catalog_reward.description_title') }}
          </h2>
        </div>
        <div class="c-card__body"
            v-html="formatRewardDetails(rewardDetails.description)">
        </div>
      </section>



      <!-- Notes -->
      <section class="c-card u-card-pad-btm" v-if="rewardDetails.notes !== null">
        <div class="c-card__header">
          <h2 class="c-card__header__title t-headline">
            {{ $t('web.catalog_reward.notes_title') }}
          </h2>
        </div>
        <div class="c-card__body"
            v-html="formatRewardDetails(rewardDetails.notes)">
        </div>
      </section>


      <!-- Properties -->
      <section
        v-if  = "orderDetails === null && (rewardProperties.length > 0 || rewardVariantProperties.length > 0)"
        class = "c-card c-card--reward-properties u-card-pad-btm"
      >
        <div class="c-card__header">
          <h2 class="c-card__header__title t-headline">
            {{ $t('web.catalog_reward.properties_title') }}
          </h2>
        </div>

        <div class="c-card__body c-card--reward-properties__body">
          <dl class="c-card--reward-properties__dl"
              v-if="rewardVariantProperties.length > 0"
              v-for="variantProperty in rewardVariantProperties">
            <dt>{{ variantProperty.name }}</dt>
            <dd>{{ variantProperty.value }}</dd>
          </dl>
          <dl class="c-card--reward-properties__dl"
              v-if="rewardProperties.length > 0"
              v-for="property in rewardProperties">
            <dt>{{ property.name }}</dt>
            <dd>{{ property.value }}</dd>
          </dl>
        </div>
      </section>

      <!-- Terms and Conditions -->
      <section class="c-card u-card-pad-btm" v-if="rewardDetails.terms_and_conditions">
        <div class="c-card__header">
          <h2 class="c-card__header__title t-headline">
            {{ $t('web.account_setup.accept_terms_link') }}
          </h2>
          <a class="t-link" style="text-decoration:none" @click.prevent="toggleTermsConditions()" href="">
            {{ $t('web.points_record.notes_toggle') }}
            <span class="c-points-record__notes__actions__link__icongroup">
              <i v-if="!showTermsConditions" class="fa fa-chevron-down is-collapsed"></i>
              <i v-if="showTermsConditions" class="fa fa-chevron-up is-expanded"></i>
            </span>
          </a>
        </div>
        <div class="c-card__body"
          v-html="formatRewardDetails(rewardDetails.terms_and_conditions)"
          v-show="showTermsConditions">
        </div>
      </section>

    </div>




    <order-modal
      v-if     = "showOrderModal"
      @close   = "closeOrderModal()"
      @confirm = "confirmOrder">
    </order-modal>




    <order-confirmation
      v-if                      = "showOrderConfirmationModal"
      @close                    = "closeOrderConfirmationModal()"
      :orderConfirmationMessage = "orderConfirmationMessage">
    </order-confirmation>




    <order-error
      v-if               = "showOrderErrorModal"
      @close             = "closeOrderErrorModal()"
      :orderErrorMessage = "orderErrorMessage">
    </order-error>




    <loading-icon v-else-if="rewardDetails === null"></loading-icon>
  </div>
</template>




<script>
import VueNumeric from 'vue-numeric'
import API from '@/services'
import _ from 'lodash'
import OrderModal from '@/views/components/catalog/OrderModal'
import OrderConfirmation from '@/views/components/catalog/OrderConfirmation'
import OrderError from '@/views/components/catalog/OrderError'
import { mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    'order-modal': OrderModal,
    'order-confirmation': OrderConfirmation,
    'order-error': OrderError,
    'vue-numeric': VueNumeric
  },
  props: ['order'],
  data () {
    return {
      orderProcessing: false,
      orderErrorMessage: '',
      orderDetails: null,
      showOrderErrorModal: false,
      showOrderModal: false,
      showOrderConfirmationModal: false,
      showTermsConditions: false,
      deleteProcessing: false,
      orderQuantity: 1
    }
  },
  methods: {

    ...mapMutations(['UPDATE_PRODUCT_DETAIL']),

    formatRewardDetails (rewardDetails) {
      if (typeof rewardDetails !== 'undefined' && rewardDetails !== null) {
        return '<p class="c-card__p">' +
        rewardDetails.replace(/(?:\r\n|\r|\n)/g, '</p><p class="c-card__p">') +
        '</p>'
      }
      return ''
    },

    deleteItem () {
      if (this.rewardDetails.saved_reward_id) {
        this.deleteProcessing = true
        this.$store.dispatch('DELETE_SAVED_REWARDS', this.rewardDetails.saved_reward_id).then(resp => {
          this.deleteProcessing = false
        }).catch(() => {
          this.deleteProcessing = false
        })
      }
    },

    closeOrderErrorModal () {
      this.showOrderErrorModal = false
      this.orderErrorMessage = ''
      this.orderProcessing = false
    },

    closeOrderModal () {
      this.showOrderModal = false
      this.orderProcessing = false
    },

    closeOrderConfirmationModal () {
      this.showOrderConfirmationModal = false
      this.orderProcessing = false
    },

    orderItem () {
      this.$store.dispatch('GET_REWARD', this.$route.params.id)
      .then(() => {
        if (this.rewardDetails.supplier_items[0].availability_status.toLowerCase() !== 'available') {
          this.$router.push({ name: 'RewardUnavailable' })
        } else {
          this.orderProcessing = true

          // This can almost never happen since we disable the
          // order button if they don't have enough points, but
          // if it does, show insufficient message in the modal.
          if (!this.participantHasEnoughPoints) {
            this.orderErrorMessage = this.getInsufficientPointsMessage
            this.showOrderErrorModal = true
          }

          if (this.participantSpentPointsOverProgramLimit) {
            this.orderErrorMessage = this.getSpentPointsOverProgramLimitItemMessage
            this.showOrderErrorModal = true
            return false
          }

          if (this.participantHasEnoughPoints) {
            this.showOrderModal = true
          }
        }
      })
      .catch(error => {
        if (error.response.data.result) {
          this.orderErrorMessage = error.response.data.result.error
          this.showOrderErrorModal = true
        }
        Promise.reject(error)
      })
    },

    saveForLater () {
      this.$store.dispatch('GET_REWARD', this.$route.params.id)
      .then(() => {
        if (this.rewardDetails.supplier_items[0].availability_status.toLowerCase() !== 'available') {
          this.$router.push({ name: 'RewardUnavailable' })
        } else {
          this.orderProcessing = true
          let request = {}
          request.ro_id = this.rewardDetails.id
          request.name = this.rewardDetails.name
          request.image = JSON.stringify(this.getImageJson(this.rewardDetails.images[0]))
          request.price = this.hasRange ? this.minSalePrice : this.salePrice
          this.$store.dispatch('ADD_SAVED_REWARD', request).then(() => {
            this.orderProcessing = false
          }).catch(() => {
            this.orderProcessing = false
          })
        }
      })
      .catch(error => Promise.reject(error))
    },

    getImageJson (images) {
      let imageJson = {}
      if (images !== null && typeof images !== 'undefined') {
        if ('url' in images) {
          imageJson.original = images.url
        }
        if ('sizes' in images) {
          let keys = Object.keys(images.sizes)
          _.each(keys, (key) => {
            imageJson[key] = images.sizes[key]
          })
        }
      }
      return imageJson
    },

    confirmOrder (data) {
      let query = new URLSearchParams(data)
      this.orderQuantity = data.quantity

      if (this.isProgramTotalLimitExeeded(data)) {
        this.orderErrorMessage = this.getSpentPointsOverProgramLimitMessage
        this.showOrderErrorModal = true
        this.closeOrderModal()
        return false
      }

      return API.getAuthenticated('/rewards/order/' + this.rewardDetails.id + '?' + query)
        .then(resp => {
          this.closeOrderModal()
          this.orderDetails = resp.data.result.order
          // update points total
          this.$store.dispatch('LOAD_PARTICIPANT', this.$router)
          this.orderConfirmationMessage = this.getOrderConfirmationMessage
          this.showOrderConfirmationModal = true
          return Promise.resolve()
        })
        .catch(err => {
          this.closeOrderModal()
          if (err.response.data.result) {
            this.orderErrorMessage = err.response.data.result.error
            this.showOrderErrorModal = true
          }
          return Promise.reject(err)
        })
    },

    isProgramTotalLimitExeeded (orderData) {
      return this.hasRange
        ? ((parseFloat(orderData.point_price) * this.orderQuantity) + this.platformPointCap.points_spent_period) > this.platformPointCap.point_cap
        : ((parseFloat(this.salePrice) * this.orderQuantity) + this.platformPointCap.points_spent_period) > this.platformPointCap.point_cap
    },

    toggleTermsConditions () {
      this.showTermsConditions = !this.showTermsConditions
    }

  },
  mounted () {
    this.$store.dispatch('LOAD_PARTICIPANT', this.$router)
    this.$store.commit('UPDATE_PRODUCT_DETAIL', null)
    this.$store.dispatch('LOAD_PLATFORM_POINT_CAP', this.$router)
  },

  computed: {
    ...mapGetters([
      'participant',
      'rewardDetails',
      'platformPointCap'
    ]),

    isSavedReward () {
      if (!this.rewardDetails || typeof this.rewardDetails.id === 'undefined') {
        return false
      }
      return this.rewardDetails.saved_reward_id !== null
    },

    currencyCode () {
      if ('points_currency_code' in this.participant) {
        return this.participant.points_currency_code
      }
      return ''
    },

    rewardSpecs () {
      return this.rewardDetails !== null ? JSON.parse(this.rewardDetails.specifications) : null
    },

    participantHasEnoughPoints () {
      if (this.currencyCode === '') {
        return false
      }
      return this.participant.points_balance >= parseFloat(this.salePrice)
    },

    getInsufficientPointsMessage () {
      var x = this.salePrice - this.participant.points_balance
      return this.$t('web.catalog_reward.insufficient_points_message', { points: x })
    },

    participantSpentPointsOverProgramLimit () {
      return this.hasRange
        ? (parseFloat(this.minSalePrice) + this.platformPointCap.points_spent_period) > this.platformPointCap.point_cap
        : (parseFloat(this.salePrice) + this.platformPointCap.points_spent_period) > this.platformPointCap.point_cap
    },

    participantSpentPointsOverProgramTotalLimit () {
      return (parseFloat(this.salePrice) * this.orderQuantity + this.platformPointCap.points_spent_period) > this.platformPointCap.point_cap
    },

    getSpentPointsOverProgramLimitItemMessage () {
      return this.$t('web.catalog_reward.points_spent_over_program_limit_item_msg')
    },

    getSpentPointsOverProgramLimitMessage () {
      const remainingPoints = this.platformPointCap.point_cap - this.platformPointCap.points_spent_period
      const maxQuantity = Math.floor(remainingPoints / parseFloat(this.salePrice))
      return this.$t('web.catalog_reward.points_spent_over_program_limit_msg', { quantity: maxQuantity })
    },

    getOrderConfirmationMessage () {
      return this.$t('web.catalog_reward.order_confirmation', { reward_name: this.rewardDetails.name, order_id: this.orderDetails.program_order_id })
    },

    salePrice () {
      return this.rewardDetails.supplier_items[0].prices.sale_price[this.currencyCode] ||
        this.rewardDetails.supplier_items[0].prices.sale_price[0]
    },

    rewardProperties () {
      return this.rewardDetails.properties
        ? this.rewardDetails.properties.filter(e => e.value || e.value === 0)
        : []
    },

    rewardVariantProperties () {
      return this.rewardDetails.variant_properties
        ? this.rewardDetails.variant_properties.filter(e => e.value || e.value === 0)
        : []
    },

    hasRange () {
      return this.rewardDetails.supplier_items[0].prices.has_range
    },

    minSalePrice () {
      return this.hasRange ? this.rewardDetails['supplier_items'][0]['prices']['sale_price_range']['min'] : 0
    },

    minDefDollarPrice () {
      return this.hasRange ? parseFloat(this.rewardDetails['supplier_items'][0]['prices']['default_dollar_price_range']['min']) : 0
    },

    maxDefDollarPrice () {
      return this.hasRange ? parseFloat(this.rewardDetails['supplier_items'][0]['prices']['default_dollar_price_range']['max']) : 0
    }

  }
}
</script>

<style scoped>
.reward-name-container {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// Reward.vue?7238f8dc